export default "__VITE_ASSET__EFW4Bx$7__"